module.exports = __webpack_public_path__ + "static/openbci-unboxing-f0ff17d6bfb48eb114b7bc25fabbdf69.gif";